<template>
  <div class="chart-tip">
    <div class="line" :style="{'background-color': bgColor}"/>
    <div class="circle" :style="{'background-color': bgColor}"/>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    bgColor: {
      type: String,
      default: "#3a85ff",
    }
  },
  data() {
    return {};
  },
  created() {},
  activated() {},
  computed: {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.chart-tip {
  width: 40px;
  height: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  
  .line {
    width: 100%;
    height: 2px;
  }
  .circle {
    position: absolute;
    transform: 50% 50%;
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
}
</style>